import React, { Component } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import Icon from '../Icon/Icon';
import { ICON_TYPE_CLOSE } from '../Icon/constants';
import { getClassNames } from '../../utils';
import './Navigation.css';
import withTheme from '../../hocs/withTheme';

type NavigationProps = {
    isOpen?: boolean;
    children?: React.ReactNode;
    closeAriaLabel?: string;
    onClose?: (event?: Event | React.SyntheticEvent) => void;
    className?: string;
};

class Navigation extends Component<NavigationProps> {
    navigation: HTMLDivElement | null = null;

    static defaultProps: Partial<NavigationProps> = {
        isOpen: false,
        children: null,
        closeAriaLabel: 'Close menu',
        onClose: () => {},
    };

    constructor(props: NavigationProps) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClick);
        document.addEventListener('keydown', this.handleKeyPress);
    }

    componentDidUpdate(prevProps: NavigationProps) {
        if (this.props.isOpen) {
            const navigationLink = this.navigation?.getElementsByClassName('Navigation__link')[0] as HTMLElement | undefined;

            if (navigationLink) navigationLink.focus();
        } else if (prevProps.isOpen === true && !this.props.isOpen) {
            const headerBtn = document.querySelectorAll('.header__button[name="menu"]')[0] as HTMLElement | undefined;

            if (headerBtn) headerBtn.focus();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick);
        document.removeEventListener('keydown', this.handleKeyPress);
    }

    handleClickOutside = (event?: Event | React.SyntheticEvent) => this.props.onClose?.(event);

    handleClick(event: MouseEvent) {
        const target = event.target as HTMLElement | null;

        if (target?.classList?.contains('Navigation__link')) {
            this.props.onClose?.();
        }
    }

    handleKeyPress(event: KeyboardEvent) {
        if (event.keyCode === 27) {
            this.props.onClose?.(event);
        }
        if (event.keyCode === 9 && this.props.isOpen) {
            if (this.navigation && ![...this.navigation.children].includes(document.activeElement as Element)) {
                (this.navigation.children[0] as HTMLElement | undefined)?.focus();
            }
        }
    }

    render() {
        const {
            isOpen, children, onClose, closeAriaLabel,
        } = this.props;

        return (
            <OutsideClickHandler
                onOutsideClick={this.handleClickOutside}
            >
                <div
                    ref={(input) => { this.navigation = input; }}
                    className={getClassNames('Navigation', { Navigation_open: isOpen })}
                >
                    <button
                        type="button"
                        className="Navigation__button"
                        onClick={() => onClose?.()}
                        aria-label={closeAriaLabel}
                    >
                        <Icon type={ICON_TYPE_CLOSE} />
                    </button>
                    {children}
                </div>
            </OutsideClickHandler>
        );
    }
}

export default withTheme(Navigation);
